import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import qnsbnurlAPI from  '../../services/qn-sbn-API-url'
import { HttpErrorResponse } from '@angular/common/http';
import { AppUtils } from 'projects/dialog/src/app/shared/utilities/app-utils';
import { OneDialogConfirmationService } from '@one/angular-kit/modal';
import { CustomConfirmationDialogComponent } from '../../custom-confirmation-dialog/custom-confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'dl-bottom-action-bar',
  templateUrl: './bottom-action-bar.component.html',
  styleUrls: ['./bottom-action-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class BottomActionBarComponent implements OnInit {
  public constructor(
    public _QnSbnService:QnSbnService,
    public _QnSbnDataService:QnSbnDataService,
    private router: Router, 
    private _AppUtils:AppUtils,
    private readonly oneSnackBar: OneSnackBarService,
    private confirmationDialog: OneDialogConfirmationService,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog
  ){}
  
  @Input() public btnState = {
    isPrevDisabled: true,
    isNextDisabled: false
  };
  @Output() public stepButton = new EventEmitter<{ isPrevState: boolean; isNextState: boolean }>();
  public isSendNotificationEnabled:boolean = true; 
  public routerConfig = this.router.config.find(item => item.path === 'create-notification');
  public childPathArray;
  public isPrevDisabled = true;
  public isNextDisabled = true;
  public currentIndex = 1;
  public storedData;
  public userPermission: any;
  public titleNotification ='';
  public notificationId = '';
  public duplicates: any = [];
  public contactLimitNumber: number = 5000;
  public isButtonDisabled: boolean = false;
  public DueDateEnabled: boolean = true;
  public feedbackEnabled: boolean = true;
  public enableDailyReport: boolean = true;
  public nonSavedFeedback: boolean = false;
  public isValid: boolean = false;
  public fbDisabledAndEnabled: boolean = false;
  public feedbackAdded: boolean = false;
  public feedbackEdited: boolean = false;

  public DocumentEnabled: boolean = true;
  
  public ngOnInit(): void {
    this.userPermission = this._QnSbnService.getUserData();
    
    this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      this.storedData = storeData;
      this.btnSendNotificationEnabledCheck();
    })
   
    if(this.routerConfig){
      this.childPathArray =  this.routerConfig.children.map(item => item.path);
    }

    this.titleNotification = this.storedData.localNotificationId.LocalId;
    this.notificationId = this.storedData.localNotificationId.NotificationId;

    this._QnSbnDataService.DueDateEnabled$.subscribe(
      res =>{
        this.DueDateEnabled = res;
      } 
    )

     this._QnSbnDataService.FeedbackEnabled$.subscribe(
      res =>{
        this.feedbackEnabled = res;
      } 
    )

    this._QnSbnDataService.DailyReportEnabled$.subscribe(
      res =>{
        this.enableDailyReport = res;
      }
    )
    this._QnSbnDataService.DocumentEnabled$.subscribe(
      res =>{
        this.DocumentEnabled = res;
        this.btnSendNotificationEnabledCheck();
      } 
    )
  }

  public async saveCloseNotification(): Promise<void> {
    this._QnSbnDataService.isAfoBtnDisabled$.subscribe(
      res =>{
        this.nonSavedFeedback = res;
    })
    this._QnSbnDataService.isValidFeedback$.subscribe(
      res =>{
        this.isValid = res;
    })
    this._QnSbnDataService.fbDisabledAndEnabled$.subscribe(
      res =>{
        this.fbDisabledAndEnabled = res;
      } 
    )
    this._QnSbnDataService.isFeedbackAdded$.subscribe(
      res =>{
        this.feedbackAdded = res;
      } 
    )
    this._QnSbnDataService.isEdited$.subscribe(
      res =>{
        this.feedbackEdited = res;
      } 
    )
    if((this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) || 
      (this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded && this.feedbackEdited) ||
      (!this.nonSavedFeedback && this.isValid && this.fbDisabledAndEnabled )){
      const nonSavedFeedbackDialogRef = this.dialog.open(CustomConfirmationDialogComponent, {
      data: {
        title: 'Warning',
        message: 'You have changes not applied in the feedback form controls. Please apply them to continue.',
        confirmButtonText: 'Accept'
      }
    });
      nonSavedFeedbackDialogRef.afterClosed().subscribe((confirmed: boolean) => {
      })
      this._QnSbnDataService.isAfoBtnDisabled$.next(true);
      this._QnSbnDataService.fbDisabledAndEnabled$.next(false);
    }else{
      await this._QnSbnDataService.setDDToggle(this.DueDateEnabled);
      await this._QnSbnDataService.setFBToggle(this.feedbackEnabled);
      let saveNCloseData;
      if(!this._QnSbnDataService.isEmpty(this.storedData)){
        saveNCloseData = this._QnSbnDataService.saveNcloseData(this.storedData);
      }else{
        this.oneSnackBar.open(`Please add Feedback and click on Tick icon to Save and close`, OneSnackBarType.ERROR, '', { duration: 5000 });
      } 
      // console.log('save and close button click',saveNCloseData);
      let fileData = this._QnSbnDataService.fileUploadData(this.storedData); 
      sessionStorage.setItem('reloadOverview', 'true');
      if(fileData.length> 0){
        for(let f=0;f<=(fileData.length-1);f++){
          if(fileData[f].uploadFile) {
            this._QnSbnService.dataToBeSaveOnS3(saveNCloseData,fileData[f],this.storedData['localNotificationId']['NotificationId'],(f==(fileData.length-1)) ? true :false, false);
          } else if(f==(fileData.length-1)){
            this.saveNCloseApiCall(saveNCloseData);
          }
        } 
      } else {
        this.saveNCloseApiCall(saveNCloseData);
      }
    }
  }
 
  public saveNCloseApiCall(saveNCloseData):void {
    this.isButtonDisabled = true;
    this._QnSbnService.saveNCloseNotificationData(saveNCloseData).subscribe(res=>{
      this._QnSbnDataService.resetAll();
      this.isButtonDisabled = false;
      this.changeDetectorRef.detectChanges();
      this.router.navigateByUrl('/notification');
      this.oneSnackBar.open('Local notification saved successfully', OneSnackBarType.SUCCESS, '', { duration: 5000 });
      },(error: HttpErrorResponse) => {
      this.isButtonDisabled = false;
      this.changeDetectorRef.detectChanges();
      this._QnSbnService.httpErrorHandler(error, 'Local notification not saved successfully');
    })
  }

  public getCurrentPathIndex(): number {
    const currentNavItem = this.router.routerState.snapshot.url.split('/').pop();
    return this.childPathArray.findIndex(x => x === currentNavItem);
  }

  public btnPrevNextStepClicked(step: string): void {
    this._QnSbnDataService.isAfoBtnDisabled$.subscribe(
      res =>{
        this.nonSavedFeedback = res;
    })
    this._QnSbnDataService.isValidFeedback$.subscribe(
      res =>{
        this.isValid = res;
    })
    this._QnSbnDataService.fbDisabledAndEnabled$.subscribe(
      res =>{
        this.fbDisabledAndEnabled = res;
      } 
    )
    this._QnSbnDataService.isFeedbackAdded$.subscribe(
      res =>{
        this.feedbackAdded = res;
      } 
    )
     this._QnSbnDataService.isEdited$.subscribe(
      res =>{
        this.feedbackEdited = res;
      } 
    )
    if((this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) || 
      (this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded && this.feedbackEdited) ||
      (!this.nonSavedFeedback && this.isValid && this.fbDisabledAndEnabled )){
      const nonSavedFeedbackDialogRef = this.dialog.open(CustomConfirmationDialogComponent, {
      data: {
        title: 'Warning',
        message: 'You have changes not applied in the feedback form controls. Please apply them to continue.',
        confirmButtonText: 'Accept'
      }
    });
      nonSavedFeedbackDialogRef.afterClosed().subscribe((confirmed: boolean) => {
      })
      this._QnSbnDataService.isAfoBtnDisabled$.next(true);
      this._QnSbnDataService.fbDisabledAndEnabled$.next(false);
    }else{
    this.currentIndex = step === 'prev' ? this.getCurrentPathIndex() - 1 : this.getCurrentPathIndex() + 1;
    // console.log(this.childPathArray);
    // console.log(this.currentIndex);
    if (this.currentIndex === 1) {
      this.isPrevDisabled = true;
    } else if (this.currentIndex === this.childPathArray.length - 2) {
      this.isNextDisabled = true;
      this.isPrevDisabled = false;
    } else {
      this.isNextDisabled = false;
      this.isPrevDisabled = false;
    }
    this.stepButton.emit({ isPrevState: this.isPrevDisabled, isNextState: this.isNextDisabled });
    this.router.navigateByUrl(`/create-notification/` + this.childPathArray[this.currentIndex]);
  }
  }

  isValidDate(dateObject){
    return new Date(dateObject).toString() !== 'Invalid Date';
  }

  public btnSendNotificationEnabledCheck(): void {
    sessionStorage.setItem('reloadOverview', 'true');
    
    // Check document requirement based on DocumentEnabled toggle
    let documentCheck = true;
    if(this.DocumentEnabled) {
      // Documents are required when DocumentEnabled is true
      documentCheck = ((this.storedData.notificationDoc || !this._QnSbnDataService.isEmpty(this.storedData.notificationDoc)) || (Array.isArray(this.storedData.notificationDocFileList) && this.storedData.notificationDocFileList.length > 0 ));
    }
    // If DocumentEnabled is false, documents are not required, so documentCheck remains true
    
    if(this.DueDateEnabled){
      if(
        documentCheck
        && (!this._QnSbnDataService.isEmpty(this.storedData.recipientData) && Array.isArray(this.storedData.recipientData.recipientTable) && this.storedData.recipientData.recipientTable.length > 0 && this.storedData.recipientData.recipientTable.length <= this.contactLimitNumber && this.findDuplicates(this.storedData.recipientData.recipientTable).length <= 0 && this.findEmpties(this.storedData.recipientData.recipientTable).length <= 0)
        && (!this._QnSbnDataService.isEmpty(this.storedData.messageAttachment) && this.storedData.messageAttachment.subjectName && this._AppUtils.extractContent(this.storedData.messageAttachment.messageAttachmentRTEText) !== "undefined" && this._AppUtils.extractContent(this.storedData.messageAttachment.messageAttachmentRTEText) !== "")
        && (!this._QnSbnDataService.isEmpty(this.storedData.feedbackDueDate) && this.isValidDate(this._QnSbnDataService.storageForQnsbn.feedbackDueDate.feedbackDueDate)
        && (!this._QnSbnDataService.isEmpty(this.storedData.dailyReportSendTo) && this.storedData.dailyReportSendTo !== "" && Array.isArray(this.storedData.dailyReportContent) && this.storedData.dailyReportContent.length > 0 || !this.enableDailyReport))
      ){
        this.isSendNotificationEnabled = false;
      }else{
        this.isSendNotificationEnabled = true;
      }
    }else{
      if(
        documentCheck
        && (!this._QnSbnDataService.isEmpty(this.storedData.recipientData) && Array.isArray(this.storedData.recipientData.recipientTable) && this.storedData.recipientData.recipientTable.length > 0 && this.storedData.recipientData.recipientTable.length <= this.contactLimitNumber && this.findDuplicates(this.storedData.recipientData.recipientTable).length <= 0 && this.findEmpties(this.storedData.recipientData.recipientTable).length <= 0)
        && (!this._QnSbnDataService.isEmpty(this.storedData.messageAttachment) && this.storedData.messageAttachment.subjectName && this._AppUtils.extractContent(this.storedData.messageAttachment.messageAttachmentRTEText) !== "undefined" && this._AppUtils.extractContent(this.storedData.messageAttachment.messageAttachmentRTEText) !== ""
        && (!this._QnSbnDataService.isEmpty(this.storedData.dailyReportSendTo) && this.storedData.dailyReportSendTo !== "" && Array.isArray(this.storedData.dailyReportContent) && this.storedData.dailyReportContent.length > 0 || !this.enableDailyReport))
      ){
        this.isSendNotificationEnabled = false;
      }else{
        this.isSendNotificationEnabled = true;
      }
    }
    this.changeDetectorRef.detectChanges();
  }

  public async btnSendNotificationClicked(): Promise<void> {
    await this._QnSbnDataService.setDDToggle(this.DueDateEnabled);
    await this._QnSbnDataService.setFBToggle(this.feedbackEnabled);
    await this._QnSbnDataService.setDRToggle(this.enableDailyReport);
    await this._QnSbnDataService.setDocumentToggle(this.DocumentEnabled);

    let sendNData;
    if(!this._QnSbnDataService.isEmpty(this.storedData)){
      sendNData = this._QnSbnDataService.saveNcloseData(this.storedData);
    } 

    let fileData = this._QnSbnDataService.fileUploadData(this.storedData); 
    sessionStorage.setItem('reloadOverview', 'true');
    if(fileData.length > 0){
      for(let f=0;f<=(fileData.length-1);f++){
        if(fileData[f].uploadFile) {
          this._QnSbnService.dataToBeSaveOnS3(sendNData,fileData[f],this.storedData['localNotificationId']['NotificationId'],(f==(fileData.length-1)) ? true :false, true);
        } else if(f==(fileData.length-1)){
          this.sendNotificationApiCall(sendNData);
        }
      }        
    } else {
      this.sendNotificationApiCall(sendNData);
    }
  }

  public sendNotificationApiCall(sendNData):void {
    this.isButtonDisabled = true;
    this._QnSbnService.sendNotificationData(sendNData).subscribe(res=>{
      this._QnSbnDataService.resetAll();
      this.isButtonDisabled = false;
      this.changeDetectorRef.detectChanges();
      this.router.navigateByUrl('/notification');
      this.oneSnackBar.open(`Notification sent successfully`, OneSnackBarType.SUCCESS, '', { duration: 5000 });
    },(error: HttpErrorResponse) => {
      this.isButtonDisabled = false;
      this.changeDetectorRef.detectChanges();
      this._QnSbnService.httpErrorHandler(error, 'Sending local notification failed.');
    });
  }

  public discardDraftNotification(): void {
    const deleteDialogRef = this.confirmationDialog.open('Delete notification', 'Do you want to delete this draft notification', 'Delete', 'Cancel');
    deleteDialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this._QnSbnService.deleteDraftNotification(this.notificationId).subscribe(
          (res) => {
            this.router.navigateByUrl('/notification');
            this.oneSnackBar.open(`The draft notification '${this.titleNotification}' deleted successfully`, OneSnackBarType.SUCCESS, '', { duration: 5000 });
          },
          (error: HttpErrorResponse) => {
            // console.log('error:', error);
            this.oneSnackBar.open('Please try again later', OneSnackBarType.ERROR, '', { duration: 5000 });
          }
        );
      }
    });
  }

  public findDuplicates(arr) {
    return arr.filter((target, index) => {
      return (
        arr.some((obj, targetIndex) => 
        index !== targetIndex && 
        obj.customerId === target.customerId &&
        obj.customerEmail === target.customerEmail)
      )
      || (
        arr.some((obj, targetIndex)  => 
        index !== targetIndex && 
        obj.customerId === target.customerId && 
        obj.customerName !== target.customerName)
      ) ;
    });
  }

  public findEmpties(arr) {
    return arr.filter((i)=>{
      if((i.customerContactName===undefined || '' || null) || (i.customerEmail===undefined || '' || null) || (i.customerId===undefined || '' || null) || (i.customerName===undefined || '' || null) || (i.sourceName===undefined || '' || null)){
        return true;
      }
    })
  }
}
